/**
 * Shared audit formatting and helper utilities for TRDR Flight Recorder UI
 */

export function parsePayload(raw) {
  if (!raw) return {};
  if (typeof raw === 'object') return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

export function safeNumber(val, fallback = 0) {
  if (val === null || val === undefined || val === '') return fallback;
  const num = Number(val);
  return isNaN(num) ? fallback : num;
}

export function formatPrice(val, decimals = 2) {
  if (val === null || val === undefined || val === '') return '-';
  const num = Number(val);
  if (isNaN(num)) return '-';
  return `₹${num.toFixed(decimals)}`;
}

export function formatTimestamp(ts, timeFormat = 'UTC') {
  if (!ts) return '-';
  const d = new Date(ts);
  if (isNaN(d.getTime())) return ts;
  if (timeFormat === 'IST') {
    return d.toLocaleTimeString('en-IN', {
      timeZone: 'Asia/Kolkata',
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      fractionalSecondDigits: 3,
    });
  }
  return d.toISOString().slice(11, 23);
}

export function formatFullTimestamp(ts) {
  if (!ts) return '-';
  const d = new Date(ts);
  return isNaN(d.getTime()) ? ts : d.toISOString().replace('T', ' ').replace('Z', ' UTC');
}

export function getEventBadgeClass(type) {
  if (!type) return 'bg-slate';
  const t = String(type).toUpperCase();
  if (t.includes('FILL') || t.includes('PASSED') || t.includes('VERIFIED')) return 'bg-green';
  if (t.includes('REJECT') || t.includes('CANCEL') || t.includes('MISMATCH')) return 'bg-red';
  if (t.includes('SIGNAL')) return 'bg-purple';
  if (t.includes('DISPATCH') || t.includes('ACK')) return 'bg-blue';
  if (t.includes('TRAILING') || t.includes('MODIFIED')) return 'bg-orange';
  return 'bg-slate';
}

export function getEventBadgeColor(type) {
  if (!type) return 'gray';
  const t = String(type).toUpperCase();
  if (t.includes('FILL') || t.includes('PASSED') || t.includes('VERIFIED')) return 'green';
  if (t.includes('REJECT') || t.includes('CANCEL') || t.includes('MISMATCH')) return 'red';
  if (t.includes('SIGNAL')) return 'purple';
  if (t.includes('DISPATCH') || t.includes('ACK')) return 'blue';
  if (t.includes('TRAILING') || t.includes('MODIFIED')) return 'orange';
  return 'gray';
}
